"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Zoom_1 = __importDefault(require("@material-ui/core/Zoom"));
const Fab_1 = __importDefault(require("@material-ui/core/Fab"));
const ArrowDownward_1 = __importDefault(require("@material-ui/icons/ArrowDownward"));
exports.default = react_1.default.memo(ScrollToBottomButton);
function ScrollToBottomButton(props) {
    const [buttonVisible, setButtonVisible] = react_1.useState(false);
    react_1.useLayoutEffect(() => {
        const parentElem = props.parentElem.current;
        if (!parentElem) {
            return;
        }
        const onScroll = (e) => onScroll_toggleButtonVisibility(e.target);
        parentElem.addEventListener("scroll", onScroll);
        onScroll_toggleButtonVisibility(parentElem);
        return () => parentElem.removeEventListener("scroll", onScroll);
    }, [props.parentElem.current, buttonVisible]);
    function onScroll_toggleButtonVisibility(messagesDiv) {
        const scrollBottom = messagesDiv.scrollHeight - messagesDiv.scrollTop - messagesDiv.clientHeight;
        const shouldShowButton = scrollBottom > 50;
        if (shouldShowButton !== buttonVisible) {
            setButtonVisible(shouldShowButton);
        }
    }
    function scrollToBottom() {
        const parentElem = props.parentElem.current;
        if (parentElem) {
            parentElem.scrollTo({ top: parentElem.scrollHeight - parentElem.clientHeight });
        }
    }
    return (react_1.default.createElement(Zoom_1.default, { in: buttonVisible },
        react_1.default.createElement(Fab_1.default, { onClick: scrollToBottom, className: props.className, size: "medium" },
            react_1.default.createElement(ArrowDownward_1.default, null))));
}
